import $ from 'jquery';

export const modalTemplate = `
    <div class="ag-modal">
        <button type="button" class="ag-modal-close closer-button"><i class="ag-icon-close"></i></button>
        <div class="ag-modal-content"></div>
        <div class="ag-modal-overlay"></div>
        <div class="ag-spinner"></div>
    </div>
`;

export const accordionPopup = `
    <div class="ag-acc-popup">
        <button type="button" class="ag-modal-close closer-button"><i class="ag-icon-close"></i></button>
        <div class="ag-modal-content entry-content entry-dark"></div>
        <div class="ag-spinner"></div>
    </div>
`;

$('a[href="#cookies"]').on('click', (e) => {
    e.preventDefault();
    window.openAxeptioCookies();
});